/**
 * OBB (Oriented Bounding Box) corners for a rectangle
 * centered at (cx, cy) with size (w, h) rotated by angleDeg degrees.
 */
export function getOBBCorners(cx, cy, w, h, angleDeg) {
    const rad = angleDeg * Math.PI / 180;
    const c = Math.cos(rad), s = Math.sin(rad);
    const a = w / 2, b = h / 2;
    return [
        { x: cx - a * c + b * s, y: cy - a * s - b * c },
        { x: cx + a * c + b * s, y: cy + a * s - b * c },
        { x: cx + a * c - b * s, y: cy + a * s + b * c },
        { x: cx - a * c - b * s, y: cy - a * s + b * c },
    ];
}

/**
 * Separating Axis Theorem collision test for two convex polygons.
 * Returns true if the polygons overlap, false if separated.
 */
export function satPolygons(p1, p2) {
    for (const poly of [p1, p2]) {
        for (let i = 0; i < poly.length; i++) {
            const j = (i + 1) % poly.length;
            const nx = -(poly[j].y - poly[i].y);
            const ny = poly[j].x - poly[i].x;
            const len = Math.sqrt(nx * nx + ny * ny);
            if (len < 1e-10) continue;
            const ax = nx / len, ay = ny / len;
            const pr1 = p1.map(p => p.x * ax + p.y * ay);
            const pr2 = p2.map(p => p.x * ax + p.y * ay);
            if (Math.max(...pr1) <= Math.min(...pr2) + 2 || Math.max(...pr2) <= Math.min(...pr1) + 2) return false;
        }
    }
    return true;
}
